import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import {
  isStockLiquidationActive,
  STOCK_LIQUIDATION_URL
} from "config/stockLiquidationCampaign"
import "./StockLiquidationPopup.scss"

const StockLiquidationPopup = () => {
  const [isVisible, setIsVisible] = useState(true)
  const history = useHistory()

  const STORAGE_KEY = "stockLiquidationPopup2026Dismissed"

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      setIsVisible(false)
    }
  }, [])

  if (!isStockLiquidationActive()) return null
  if (!isVisible) return null

  const handleClose = () => {
    setIsVisible(false)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  const handleOrderClick = (e) => {
    e.preventDefault()
    history.push(STOCK_LIQUIDATION_URL)
    handleClose()
  }

  return (
    <div className="stock-liquidation-popup">
      <div className="stock-liquidation-popup__header">
        <h4 className="stock-liquidation-popup__title">
          Ai văzut? A început lichidarea de stoc!
        </h4>
        <button
          onClick={handleClose}
          className="stock-liquidation-popup__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="stock-liquidation-popup__content">
        <p>
          Peste 3.600 de produse la cele mai avantajoase prețuri de până acum.
        </p>
        <p>
          <a
            href={STOCK_LIQUIDATION_URL}
            onClick={handleOrderClick}
            className="stock-liquidation-popup__order-link"
          >
            Comandă
          </a>{" "}
          chiar azi, stocurile se epuizează rapid!
        </p>
      </div>
    </div>
  )
}

export default StockLiquidationPopup
